<p-button
  (onClick)="handleClick($event)"
  [class.block]="fluid()"
  [class.w-full]="fluid()"
  [disabled]="disabled()"
  [fluid]="true"
  [label]="label()"
  [loading]="loading()"
  [ngClass]="[theme()]"
  [rounded]="false"
  [style.max-width]="maxWidth()"
  [type]="type()"
  appPrimengButton
  styleClass="uppercase py-1" />
